import * as Sentry from '@sentry/react'

import api from '@libs/api'

import { handleServiceError } from '@utils/errors'

const fetchSignedUploadUrl = async ({
  apiPath,
  contentType,
  contentLength,
}: {
  apiPath: string
  contentType: string
  contentLength: number
}): Promise<{ fileName: string; signedUploadUrl: string }> => {
  const queryString = {
    contentType,
    contentLength: String(contentLength),
  }

  try {
    const response = await api.get({
      path: `${apiPath}/sign-upload-url`,
      queryString,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const uploadFile = async ({
  apiPath,
  data,
}: {
  apiPath: string
  data: File
}) => {
  const contentType = data.type
  const contentLength = data.size

  const { fileName, signedUploadUrl } = await fetchSignedUploadUrl({
    apiPath,
    contentType,
    contentLength,
  })

  const response = await fetch(signedUploadUrl, { method: 'PUT', body: data })

  if (!response.ok) {
    const error = Error(response.statusText)
    Sentry.captureException(error)
    throw error
  }

  return fileName
}

export default {
  uploadFile,
}
